/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { useEffect, useMemo, useRef, useState } from "react";
import { useOutsideClick } from "../../../utils/helper";
import { DEFAULT_PAGE_SIZE, DEFAULT_PAGE } from "../../../utils/constants";
import { Helmet } from "react-helmet";
import Table from "../../../component/common/Table";
import Pagination from "../../../component/common/Pagination/Pagination";
import {
  Description,
  Dialog,
  DialogPanel,
  DialogTitle,
  DialogBackdrop,
} from "@headlessui/react";
import { Api } from "../../../api";
import { CommonTable } from "../../../component/common/table2/CommonTable";
import moment from "moment";
import { SpecialistPageData } from '../../../utils/pageContent';

const columns = [
  {
    title: SpecialistPageData.complaintTabData.tableHeaderText.userEmailAddress,
    key: 'email',
    type: 'text',
    align: 'left',
    darkText: false
  },
  {
    title: SpecialistPageData.complaintTabData.tableHeaderText.complaint,
    key: 'complaint',
    type: 'text3',
    align: 'left',
    setPopup: 'setShowPopup',
    showPopup: 'showPopup',
    longText: true,
    darkText: true,
  },
  {
    title: SpecialistPageData.complaintTabData.tableHeaderText.complaintAgainst,
    key: 'name',
    type: 'text',
    align: 'left',
    darkText: false
  },
  {
    title: SpecialistPageData.complaintTabData.tableHeaderText.date,
    key: 'date',
    type: 'date',
    align: 'left',
    darkText: false
  },
  {
    title: SpecialistPageData.complaintTabData.tableHeaderText.resolved,
    key: 'status',
    type: 'checkBox',
    align: 'center',
    darkText: false
  }
];

const initialComplaintsData = SpecialistPageData.complaintTabData.tableData;

function Complaint() {
  const [activeTab, setActiveTab] = useState("All");
  const wrapperRef = useRef(null);
  const [complainsList, setComplaintsList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(DEFAULT_PAGE);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [tab, setTab] = useState(1);
  const [openComplaintModal, setOpenComplaintModal] = useState(false);
  const pageData = SpecialistPageData.complaintTabData;
  const [selectedComplaint, setSelectedComplaint] = useState(null);
  const [loading, setLoading] = useState(true);
  const [resolvedComplainsCount, setResolvedComplaintsCount] = useState();
  const [unresolvedComplainsCount, setUnResolvedComplaintsCount] = useState();

  const fetchData = async (page = DEFAULT_PAGE) => {
    try {
      setLoading(true);
      const response = await Api.getComplaintList(
        page,
        DEFAULT_PAGE_SIZE,
        activeTab === "Resolved" ? 2 : activeTab === "Unresolved" ? 1 : "All"
      );
      if (response?.data?.meta?.code === 200) {
        console.log("🚀 ~ Fetching Data ~ response:", response);
        setResolvedComplaintsCount(response?.data?.meta?.statusCounts?.status2);
        setUnResolvedComplaintsCount(
          response?.data?.meta?.statusCounts?.status1
        );
        setComplaintsList(response.data.data);
        setTotalCount(response.data.meta.total);
      }
    } catch (error) {
      console.error("🚀 ~ Fetching Data ~ error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage, activeTab]);

  const handleComplaintClick = (complaint) => {
    setSelectedComplaint(complaint);
    setOpenComplaintModal(true);
  };

  useOutsideClick(wrapperRef, () => {
    if (showFilterModal) setShowFilterModal(!showFilterModal);
  });

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  /* COLUMNS */
  const columns = useMemo(
    () => [
      {
        accessorKey: "email",
        header: "User email address",
        cell: ({ row }) => {
          return (
            <div className="text-left">
              <div className="text-sm font-normal capitalize text-black dark:text-white">
                {row?.original?.user_id?.email}
              </div>
            </div>
          );
        },
        enableSorting: false,
        enableHiding: false,
      },
      {
        accessorKey: "complaint",
        header: "Complaint",
        cell: ({ row }) => {
          return (
            <div className="text-left">
              <div className="text-sm font-normal capitalize text-black dark:text-white">
                {row?.original?.complaint}
              </div>
            </div>
          );
        },
        enableSorting: false,
        enableHiding: false,
      },
      {
        accessorKey: "complaint_against",
        header: "Complaint against",
        cell: ({ row }) => {
          return (
            <div className="text-left">
              <div className="text-sm font-normal capitalize text-black dark:text-white">
                {row?.original?.session_id?.doctor_user_id?.first_name}{" "}
                {row?.original?.session_id?.doctor_user_id?.last_name}
              </div>
            </div>
          );
        },
        enableSorting: false,
        enableHiding: false,
      },
      {
        accessorKey: "complain_date",
        header: "Date",
        cell: ({ row }) => {
          return (
            <div className="text-left">
              <div className="text-sm font-normal capitalize text-black dark:text-white">
                {moment(row?.original?.createdAt).format("DD.MM.YYYY")}
              </div>
            </div>
          );
        },
        enableSorting: false,
        enableHiding: false,
      },
      {
        accessorKey: "resolved",
        header: "Resolved?",
        cell: ({ row }) => {
          return (
            <div className="text-center">
              {row?.original?.status !== 3 ? (
                <input
                  type="checkbox"
                  className="cursor-pointer h-4 w-4 rounded border border-[blue] accent-shoorah-primary sm:left-6"
                  checked={row?.original?.status === 2}
                  onClick={() => handleComplaintClick(row?.original)}
                />
              ) : (
                <p className="text-red-500 bg-red-100/50 rounded-full px-3 py-1 text-xs leading-5 capitalize">
                  Closed
                </p>
              )}
            </div>
          );
        },
        enableSorting: false,
        enableHiding: false,
      },
    ],
    [complainsList]
  );

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-lg">Loading complaints...</div>
      </div>
    );
  }

  console.log("Complaints: ", complainsList);

  return (
    <div className="relative">
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@500&family=Ubuntu&family=Work+Sans:ital,wght@0,100..900;1,100..900&display=swap"
          rel="stylesheet"
        />
        <meta charSet="utf-8" />
        <title>{pageData.metaTitle}</title>
      </Helmet>

      {openComplaintModal && selectedComplaint ? (
        <Dialog
          open={openComplaintModal}
          onClose={() => {
            setOpenComplaintModal(false);
            setSelectedComplaint(null);
          }}
          className="relative z-50"
        >
          <DialogPanel>
            <div
              className="fixed inset-0 z-40 flex w-screen items-center justify-center bg-black/25"
              style={{ fontSize: "1.20em" }}
            >
              <div
                className="w-[95vw] overflow-hidden border border-[#F1F2F4] bg-white pt-0 shadow-md dark:border-none dark:bg-shoorah-darkBgColor dark:text-white lg:w-[50vw]"
                style={{ borderRadius: "30px" }}
              >
                <div className="items-left mb-2 mt-8 flex w-full gap-[1rem] px-8">
                  <div
                    className={
                      tab === 1
                        ? `items-left ease flex w-full cursor-pointer justify-between px-6 py-1 font-medium duration-1000`
                        : `flex w-full cursor-pointer items-center justify-between py-3 font-medium`
                    }
                  >
                    <DialogTitle>
                      <div className="hover:shoorah-primary items-center border-none text-2xl font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg focus:outline-none">
                        {pageData.complaintModalData.complaintText}{' '}
                        {'#' + initialComplaintsData[3].id}
                      </div>
                    </DialogTitle>
                  </div>
                </div>

                <div>
                  <div className="px-4">
                    <div className="justify-center gap-5">
                      <div className="mt-3 flex w-full flex-col justify-between">
                        <label
                          className="text-md relative left-[45px] my-1 flex font-medium text-gray-400 dark:text-white"
                          htmlFor="user_email"
                        >
                          {pageData.complaintModalData.userEmailText}
                          <div className="relative left-[25px] flex">
                            <span
                              className={`text-md text-gray-700 dark:text-shoorah-gray2`}
                            >
                              {selectedComplaint?.user_id?.email || "N/A"}
                            </span>
                          </div>
                        </label>
                      </div>
                      <div className="mt-5 flex w-full flex-col justify-between">
                        <label
                          className="text-md relative left-[45px] my-1 flex font-medium text-gray-400 dark:text-white"
                          htmlFor="date_raised"
                        >
                          {pageData.complaintModalData.dateRaisedText}
                          <div className="relative left-[17px] flex">
                            <span
                              className={`text-gray-700 dark:text-shoorah-gray2`}
                            >
                              {moment(selectedComplaint?.createdAt).format(
                                "DD.MM.YYYY"
                              ) || "N/A"}
                            </span>
                          </div>
                        </label>
                      </div>
                      <div className="mt-5 flex w-full flex-col justify-between">
                        <label
                          className="text-md relative left-[45px] my-1 flex font-medium text-gray-400 dark:text-white"
                          htmlFor="complaint_against"
                        >
                          Complaint Against:
                          <div className="relative left-[5px] flex">
                            <span
                              className={`text-gray-700 dark:text-shoorah-gray2`}
                            >
                              {
                                selectedComplaint?.session_id?.doctor_user_id
                                  ?.first_name
                              }{" "}
                              {
                                selectedComplaint?.session_id?.doctor_user_id
                                  ?.last_name
                              }
                            </span>
                          </div>
                        </label>
                      </div>
                      <div className="mt-5 flex w-full flex-col justify-between">
                        <label
                          className="text-md relative left-[45px] my-1 flex font-medium text-gray-400 dark:text-white"
                          htmlFor="status"
                        >
                          Status:
                          <div className="relative left-[35px] flex">
                            <span
                              className={`text-gray-700 dark:text-shoorah-gray2 ${
                                selectedComplaint?.status === 2
                                  ? "text-green-600"
                                  : "text-red-600"
                              }`}
                            >
                              {selectedComplaint?.status === 2
                                ? "Resolved"
                                : "Unresolved"}
                            </span>
                          </div>
                        </label>
                      </div>
                    </div>

                    <div className="flex justify-center gap-5 pt-5">
                      <div className="flex w-full flex-col">
                        <label
                          htmlFor="complaint_text"
                          className="text-md relative left-[45px] my-1 flex font-medium text-gray-400 dark:text-white"
                        >
                          {pageData.complaintModalData.complainant}
                        </label>
                        <div>
                          <p
                            className={`relative left-[45px] top-[10px] flex w-5/6 whitespace-pre-line font-medium text-gray-700 dark:text-shoorah-gray2`}
                            style={{ whiteSpace: "pre-line" }}
                          >
                            {selectedComplaint?.complaint ||
                              "No complaint text available"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="text-medium mb-4 flex justify-center pb-5 pt-8">
                    <button
                      onClick={() => {
                        console.log(
                          "Respond to complaint:",
                          selectedComplaint?.id
                        );
                        setOpenComplaintModal(false);
                        setSelectedComplaint(null);
                      }}
                      className="mt-4 bg-shoorah-secondary px-16 py-2 text-center text-white"
                      style={{ borderRadius: "50px" }}
                    >
                      {pageData.complaintModalData.respondViaEmailText}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </DialogPanel>
        </Dialog>
      ) : null}

      <div className="mt-5 p-6 bg-white rounded-2xl dark:border-none border-[1.5px] dark:bg-shoorah-darkBgTabColor border-shoorah-borderGray">
        <div className="flex items-center gap-3">
          <div
            onClick={() => setActiveTab("All")}
            className={classNames(
              activeTab === "All"
                ? "border-black text-black dark:text-white"
                : "border-gray-200",
              "flex items-center gap-2 cursor-pointer hover:text-gray-600 border rounded-full px-4 py-2 text-sm"
            )}
          >
            {pageData.tabList.all}{" "}
            <span className="px-3 py-1 text-xs font-medium bg-[#E5EAF9] rounded-full text-shoorah-primary">
              {totalCount}
            </span>{" "}
          </div>
          <div
            onClick={() => setActiveTab("Resolved")}
            className={classNames(
              activeTab === "Resolved"
                ? "border-black text-black dark:text-white"
                : "border-gray-200",
              "flex items-center gap-2 cursor-pointer hover:text-gray-600 border rounded-full px-4 py-2 text-sm"
            )}
          >
            {pageData.tabList.resolved}{" "}
            <span className="px-3 py-1 text-xs font-medium bg-[#DDF2BF] rounded-full text-[#438038]">
              {resolvedComplainsCount}
            </span>{" "}
          </div>
          <div
            onClick={() => setActiveTab("Unresolved")}
            className={classNames(
              activeTab === "Unresolved"
                ? "border-black text-black dark:text-white"
                : "border-gray-200",
              "flex items-center gap-2 cursor-pointer hover:text-gray-600 border rounded-full px-4 py-2 text-sm"
            )}
          >
            {pageData.tabList.unresolved}{" "}
            <span className="px-3 py-1 text-xs font-medium bg-[#FFFDD2] rounded-full text-[#CCB014]">
              {unresolvedComplainsCount}
            </span>{" "}
          </div>
        </div>
        <div className="mt-6">
          <CommonTable
            data={
              activeTab === "Resolved"
                ? complainsList?.filter((item) => item?.status === 2)
                : activeTab === "Unresolved"
                ? complainsList?.filter((item) => item?.status === 1)
                : complainsList || []
            }
            columns={columns}
            noExtraRow
          />
        </div>
        <div>
          {totalCount > DEFAULT_PAGE_SIZE ? (
            <Pagination
              currentPage={currentPage}
              totalCount={totalCount}
              pageSize={DEFAULT_PAGE_SIZE}
              onPageChange={handlePageChange}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default Complaint;
